import { gql } from '@apollo/client'
import { POST_ITEM_USER } from './fragments'

/** 获取返图列表 */
export const GET_BACK_IMAGE_LIST = gql`
  ${POST_ITEM_USER}
  query getBackImageList($first: Int, $offset: Int, $postId: Long) {
    squareModule {
      postBackImagePage(
        page: { first: $first, offset: $offset }
        postId: $postId
      ) {
        edges {
          node {
            id
            artWorkUrl
            width: length
            height: width
            userInfo {
              ...postItemUser
            }
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`
/** 返图 */
export const BACK_IMAGE_POST = gql`
  mutation backImagePost($aiArtworkId: Long) {
    squareModule {
      postId: backImageToAiArtworkPost(aiArtworkId: $aiArtworkId)
    }
  }
`
/** 删除返图 */
export const DELETE_BACK_IMAGE = gql`
  mutation deleteBackImage($aiArtworkId: Long) {
    squareModule {
      status: deleteBackImage(aiArtworkId: $aiArtworkId)
    }
  }
`
